import { render } from "./MailDone.vue?vue&type=template&id=4dcbd7f0"
import script from "./MailDone.vue?vue&type=script&lang=js"
export * from "./MailDone.vue?vue&type=script&lang=js"

import "./MailDone.vue?vue&type=style&index=0&id=4dcbd7f0&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__